import { createSelector } from '@reduxjs/toolkit';
import { selectRegionalDistrictsModal } from './selectRegionalDistrictsModal';
import { IRegionalDistrict } from 'shared/types/geo';

export const selectRegionalDistrictById = (districtId: number) =>
  createSelector(
    selectRegionalDistrictsModal,
    ({ districts }) => districts.find(({ id }) => id === districtId) as IRegionalDistrict,
  );
